import { faker } from '@faker-js/faker';

import type { ChangePasswordPostResponse } from '../types/ChangePasswordPostResponse';

export function createChangePasswordPostResponse(
  data: NonNullable<Partial<ChangePasswordPostResponse>> = {}
): NonNullable<ChangePasswordPostResponse> {
  return {
    ...{
      data: {},
      response: {
        date: faker.string.alpha(),
        messages: faker.helpers.arrayElements([faker.string.alpha()]) as any,
        status: faker.number.int(),
        type: faker.string.alpha(),
      },
    },
    ...data,
  };
}
